/**
 * Validates multiple-choice quiz answer indices.
 */

export function isValidAnswerIndex(index: number | null | undefined): boolean {
  if (index === null || index === undefined) return false;
  return Number.isInteger(index) && index >= 0 && index <= 3;
}
